import { gql } from '@apollo/client';

export const UPDATE_DOOPIE_REGISTER_MUTATION = gql`
  mutation updateDoopieRegister($data: UpdateDoopieRegisterInput!) {
    updateDoopieRegister(data: $data) {
      success
    }
  }
`;
